import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import PropTypes from "prop-types";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const IncomeVsExpensesChart = ({ data, formatAmount, isDark }) => {
  if (!data || data.length === 0) return null;

  const chartData = {
    labels: data.map((d) => d.month),
    datasets: [
      {
        label: "Ingresos",
        data: data.map((d) => d.income),
        backgroundColor: "rgba(34, 197, 94, 0.7)",
        borderColor: "rgb(34, 197, 94)",
        borderWidth: 1,
        borderRadius: 6
      },
      {
        label: "Gastos",
        data: data.map((d) => d.expenses),
        backgroundColor: "rgba(239, 68, 68, 0.7)",
        borderColor: "rgb(239, 68, 68)",
        borderWidth: 1,
        borderRadius: 6
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          usePointStyle: true,
          padding: 20,
          color: isDark ? "#9ca3af" : "#6b7280"
        }
      },
      tooltip: {
        callbacks: {
          label: (ctx) => formatAmount ? `${ctx.dataset.label}: ${formatAmount(ctx.raw)}` : `${ctx.dataset.label}: ${ctx.raw}`
        }
      }
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: {
          color: isDark ? "#9ca3af" : "#6b7280",
          maxRotation: 0
        }
      },
      y: {
        beginAtZero: true,
        grid: {
          color: isDark ? "rgba(75, 85, 99, 0.3)" : "rgba(229, 231, 235, 1)"
        },
        ticks: {
          color: isDark ? "#9ca3af" : "#6b7280"
        }
      }
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200/50 dark:border-gray-700/50 p-6">
      <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-6">Ingresos vs Gastos</h3>
      <div className="h-64">
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

IncomeVsExpensesChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.string.isRequired,
      income: PropTypes.number.isRequired,
      expenses: PropTypes.number.isRequired
    })
  ),
  formatAmount: PropTypes.func,
  isDark: PropTypes.bool
};

export { IncomeVsExpensesChart };
